/** Keep API names available and normalize the seeded module-action slugs. */
export function buildPermissionMap(apiPermissions) {
  return (apiPermissions || []).reduce((result, permission) => {
    const slug = String(permission.slug || '');
    if (!slug) return result;
    const granted = Number(permission.is_granted) === 1;
    result[slug] = granted;
    result[slug.replace(/-/g, '_')] = granted;
    return result;
  }, {});
}
